import type { DevelopmentProfileType } from '@homeviews/models'

class DevelopmentType {
  public static hasMediaGallery(developmentType: DevelopmentProfileType) {
    switch (developmentType) {
      case 'marketing':
      case 'bts-marketing':
      case 'bts-brand':
      case 'btr-marketing':
      case 'off-plan':
        return true
      default:
        return false
    }
  }

  public static isPaidProfile(developmentType: DevelopmentProfileType) {
    switch (developmentType) {
      case 'marketing':
      case 'bts-marketing':
      case 'bts-brand':
      case 'agency':
      case 'btr-marketing':
      case 'off-plan':
        return true
      default:
        return false
    }
  }
}

export default DevelopmentType
